export type ModalFooterProps = {
  children: React.ReactNode;
  className?: string;
};
import { cx } from "@/utils";

import styles from "../Modal.module.css";

const ModalFooter: React.FunctionComponent<ModalFooterProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cx(styles.footer, styles.padding, className)}>
      {children}
    </div>
  );
};

export default ModalFooter;
